<template>
    <div class="CSChatThai" style="background: #2562af;">
      <!-- sss -->

<!-- 
       <v-avatar size="40" v-for="(v,index) in listUserOnline" class="defaultPicOnline">
         <v-badge rigth bottom color="#1ace21" >
         <template v-slot:badge>
           <span></span>
         </template>
  <img :src="backend + v.profile_picture" v-if="v.profile_picture" /> 
         <span class="headline colorAvatar ">{{v}}</span>
       </v-badge>
    </v-avatar>
 -->
 <div v-if="stateShow == 'showMenu'">
<div style="background: #2562af;">
<v-layout row wrap style="">
  <v-flex xs11 xl11 lg11 md11 sm11 >
<div style="padding-left: 10px;">
       <v-text-field color="white" hide-details append-icon="search" label="ค้นหาเพื่อนหรือกลุ่ม" solo clearable v-model="search"  class="bgsearchweb CSChatThai" style="color: white !important;"></v-text-field>
    </div>
  </v-flex>
  <v-flex xs1 xl1 lg1 md1 sm1 style="display: flex;
    justify-content: center;
    vertical-align: middle;
    position: relative;">

    <div style="">
       <v-menu offset-y >
        <template v-slot:activator="{ on }">
      <v-btn icon small style="background: #0000001c;    margin: 0 -15px;position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);"v-on="on">
        <v-icon color="white">mdi-dots-vertical</v-icon>
      </v-btn>
        </template>
        <v-list style="padding: 0;">
          <v-list-tile
              @click="gotopath('/my_profile')"
          >
            <v-list-tile-title style="font-size: 12px !important;">โปรไฟล์</v-list-tile-title>
          </v-list-tile>

          <v-list-tile
              @click="gotopath('/add_friend')"
          >
            <v-list-tile-title style="font-size: 12px !important;">เพิ่มเพื่อน</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
  </v-flex>
</v-layout>



<div>
 <v-layout row wrap style="padding: 10px !important;">
  <v-flex xs3 xl3 lg3 md3 sm3  @click="selectedTabMenu('friend')">
    <div :class="(TabMenu == 'friend')? 'Menu_headerStyle_Selected':'Menu_headerStyle'">
      <span>เพื่อน</span>
    </div>
  </v-flex>
  <v-flex xs3 xl3 lg3 md3 sm3 @click="selectedTabMenu('group')">
    <div  :class="(TabMenu == 'group')? 'Menu_headerStyle_Selected':'Menu_headerStyle'" >
    <span>กลุ่ม</span>
  </div>
  </v-flex>
  <v-flex xs3 xl3 lg3 md3 sm3  @click="selectedTabMenu('chat')">
    <div :class="(TabMenu == 'chat')? 'Menu_headerStyle_Selected':'Menu_headerStyle'">
    <span>แชท</span>
  </div>
  </v-flex>
 </v-layout>
</div>

  </div>




<div style="padding-right: 10px;padding-left: 10px;border-top-left-radius: 20px !important;border-top-right-radius: 20px !important;background: white;padding-bottom: 10px;height: 90%;">

  <div style="border-top-left-radius: 10px !important;border-top-right-radius: 10px !important;background: white;padding-bottom: 10px;height: calc(100vh - 145px) !important;overflow-y: scroll;">
    <div v-if="TabMenu == 'friend' || (TabMenu == 'chat' && FilterChatList.length == 0)" style="padding: 12px 0px 0px 0px;justify-content: center;
    display: flex;">
    <div class="createGroupStyle" @click="gotopath('/add_friend')">
<v-layout row wrap>
  <v-flex xs2 xl2 lg2 md2 sm2>
      <v-avatar color="white"  size="40px">
        <v-icon color="#909090" style="font-size: 24px;">person_add</v-icon>
      </v-avatar>
    </v-flex>
    <v-flex xs10 xl10 lg10 md10 sm10>
      <p style="color:#4e4e4ec2;margin-bottom: 0 !important; margin-left: 10px; font-weight: 800 !important;">เพิ่มเพื่อน</p>
      <span style="color:#909090c9;margin-bottom: 0 !important; margin-left: 10px;font-size: 12px;">ค้นหาเพื่อนที่คุณรู้จักเพื่อพูดคุย</span>
    </v-flex>
  </v-layout>
  </div>

  </div>

  <div v-else-if="TabMenu == 'group'" style="padding: 12px 0px 0px 0px;">
    <div class="createGroupStyle" @click="gotopath('/create_group')">
<v-layout row wrap>
  <v-flex xs2 xl2 lg2 md2 sm2>
      <v-avatar color="white"  size="40px">
        <v-icon color="#909090" style="font-size: 24px;">group_add</v-icon>
      </v-avatar>
    </v-flex>
    <v-flex xs10 xl10 lg10 md10 sm10>
      <p style="color:#4e4e4ec2;margin-bottom: 0 !important; margin-left: 10px; font-weight: 800 !important;">สร้างกลุ่ม</p>
      <span style="color:#909090c9;margin-bottom: 0 !important; margin-left: 10px;font-size: 12px;">สร้างกลุ่มสำหรับคุณและเพื่อน</span>
    </v-flex>
  </v-layout>
  </div>

  <div class="createGroupStyle" style="margin-top: 2px;" @click="stateShow = 'showPendingGroup'" v-if="FilterGroupPendingList.length > 0">
<v-layout row wrap>
  <v-flex xs2 xl2 lg2 md2 sm2>
      <v-avatar color="white"  size="40px">
        <v-icon color="#909090" style="font-size: 24px;">mdi-account-group</v-icon>
      </v-avatar>
    </v-flex>
    <v-flex xs10 xl10 lg10 md10 sm10 style="    margin: auto;">
      <p style="color:#4e4e4ec2;margin-bottom: 0 !important; margin-left: 10px; font-weight: 800 !important;">คำเชิญเข้ากลุ่ม ({{FilterGroupPendingList.length}})  <v-icon style="color: #4e4e4ec2 !important; font-size: 20px !important;float: right;">chevron_right</v-icon>
      </p>

    </v-flex>
  </v-layout>
  </div>

  </div>



    <v-list two-line v-if="TabMenu == 'friend' && FilterFriendList.length != 0">
      <!-- {{listFriend}} -->
<template v-for="(item, index) in FilterFriendList" >

      <v-list-tile avatar @click="selectRoom(item)">

         <v-list-tile-avatar v-if="checkOnline_user(item.friend_user_id)">
         <v-avatar size="40" :class="item.friend_profile_picture? 'defaultPicOnlinehavePic':'defaultPicOnline'">
         <v-badge rigth bottom color="#1ace21"  >
         <template v-slot:badge>
           <span></span>
         </template>
          <img :src="backend + item.friend_profile_picture" v-if="item.friend_profile_picture" class="alligator-turtle" style="width: 40px; display: table-cell;height: 40px;" />
          <span class="white--text headline" v-else style="height: 40px;width: 40px !important;display: table-cell;">{{(item.friend_display_name.length>=2)? item.friend_display_name.charAt(0)+item.friend_display_name.charAt(1):item.friend_display_name.charAt(0)}}</span>
       </v-badge>
    </v-avatar>
  </v-list-tile-avatar>

        <v-list-tile-avatar color="#2562af" size="40" v-else>   
    <img :src="backend + item.friend_profile_picture" v-if="item.friend_profile_picture" class="alligator-turtle"/>
          <span class="white--text headline" v-else>{{(item.friend_display_name.length>=2)? item.friend_display_name.charAt(0)+item.friend_display_name.charAt(1):item.friend_display_name.charAt(0)}}</span>
        </v-list-tile-avatar>







        <v-list-tile-content>
          <v-list-tile-title class="CSChatThai NameBorder" v-text="item.friend_display_name"></v-list-tile-title>
          <v-list-tile-sub-title class="CSChatThai" v-text="item.friend_status"></v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider v-if="index != FilterFriendList.length -1"></v-divider>
    </template>
    </v-list>

    

<!-- <div v-else-if="TabMenu == 'group'" style="padding: 20px 0px 0px 0px;justify-content: center;
    display: flex;">
    <div class="createGroupStyle" @click="gotopath('/create_group')">
<v-layout row wrap>
  <v-flex xs2 xl2 lg2 md2 sm2>
      <v-avatar color="white"  size="40px">
        <v-icon color="#909090" style="font-size: 24px;">mdi-account-group</v-icon>
      </v-avatar>
    </v-flex>
    <v-flex xs10 xl10 lg10 md10 sm10>
      <p style="color:#4e4e4ec2;margin-bottom: 0 !important; margin-left: 10px; font-weight: 800 !important;">สร้างกลุ่ม</p>
      <span style="color:#909090c9;margin-bottom: 0 !important; margin-left: 10px;font-size: 12px;">สร้างกลุ่มสำหรับคุณและเพื่อน</span>
    </v-flex>
  </v-layout>
  </div>

  </div>
 -->


    <v-list two-line v-else-if="TabMenu == 'group' && FilterGroupList.length != 0">

      <template v-for="(item, index) in FilterGroupList">
        <v-list-tile avatar @click="selectRoom(item)">
          <v-list-tile-avatar color="#2562af" size="40">
            <img :src="backend + item.room_picture" v-if="item.room_picture" class="alligator-turtle"/>
            <span class="white--text headline" v-else>{{(item.room_name.length>=2)? item.room_name.charAt(0)+item.room_name.charAt(1):item.room_name.charAt(0)}}</span>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title class="CSChatThai NameBorder" v-text="item.room_name"></v-list-tile-title>
            <!-- <v-list-tile-sub-title class="CSChatThai" v-text="item.friend_status"></v-list-tile-sub-title> -->
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="index != FilterGroupList.length -1"></v-divider>
      </template>
    </v-list>






  <v-list two-line v-if="TabMenu == 'chat' && FilterChatList.length != 0" >
    <template v-for="(item, index) in FilterChatList">
      <v-list-tile avatar @click="selectRoom(item)" v-if="item.room_type == 'user'">

        <!-- <v-list-tile-avatar v-if="checkOnline_user(item.friend_user_id)">

         <v-avatar size="40" class="defaultPicOnline">
         <v-badge rigth bottom color="#1ace21" >
         <template v-slot:badge>
           <span></span>
         </template>
          <img :src="backend + item.friend_profile_picture" v-if="item.friend_profile_picture" class="alligator-turtle" style="width: 40px;" />
          <span class="white--text headline" v-else>{{(item.friend_display_name.length>=2)? item.friend_display_name.charAt(0)+item.friend_display_name.charAt(1):item.friend_display_name.charAt(0)}}</span>
       </v-badge>
    </v-avatar>
  </v-list-tile-avatar>


        <v-list-tile-avatar color="#2562af" size="40" v-else>   
    <img :src="backend + item.friend_profile_picture" v-if="item.friend_profile_picture" class="alligator-turtle"/>
          <span class="white--text headline" v-else>{{(item.friend_display_name.length>=2)? item.friend_display_name.charAt(0)+item.friend_display_name.charAt(1):item.friend_display_name.charAt(0)}}</span>
        </v-list-tile-avatar>



        <v-list-tile avatar @click="selectRoom(item)"> -->

         <v-list-tile-avatar v-if="checkOnline_user(item.friend_user_id)">
         <v-avatar size="40" :class="item.friend_profile_picture? 'defaultPicOnlinehavePic':'defaultPicOnline'">
         <v-badge rigth bottom color="#1ace21"  >
         <template v-slot:badge>
           <span></span>
         </template>
          <img :src="backend + item.friend_profile_picture" v-if="item.friend_profile_picture" class="alligator-turtle" style="width: 40px; display: table-cell;height: 40px;" />
          <span class="white--text headline" v-else style="height: 40px;width: 40px !important;display: table-cell;">{{(item.friend_display_name.length>=2)? item.friend_display_name.charAt(0)+item.friend_display_name.charAt(1):item.friend_display_name.charAt(0)}}</span>
       </v-badge>
    </v-avatar>
  </v-list-tile-avatar>

        <v-list-tile-avatar color="#2562af" size="40" v-else>   
    <img :src="backend + item.friend_profile_picture" v-if="item.friend_profile_picture" class="alligator-turtle"/>
          <span class="white--text headline" v-else>{{(item.friend_display_name.length>=2)? item.friend_display_name.charAt(0)+item.friend_display_name.charAt(1):item.friend_display_name.charAt(0)}}</span>
        </v-list-tile-avatar>











        <v-list-tile-content two-line>
          <v-list-tile-title class="CSChatThai NameBorder" v-text="item.friend_display_name"></v-list-tile-title>
          <v-list-tile-sub-title class="CSChatThai">
            <span>{{setLastMessage(item)}}</span>
            
          </v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-list-tile-action-text><span class="CSChatThai timeListChat" v-if="item.last_message_time">{{time(item.last_message_time)}} </span></v-list-tile-action-text>
          
          <v-chip class="ma-2" color="red" text-color="white" v-if="item.count_not_read">
                    {{item.count_not_read}}
                </v-chip>
        </v-list-tile-action>
      </v-list-tile>


      <v-list-tile avatar @click="selectRoom(item)" v-else-if="item.room_type == 'group'">
        <v-list-tile-avatar color="#2562af" size="40">
          <img :src="backend + item.room_picture" v-if="item.room_picture" class="alligator-turtle"/>
          <span class="white--text headline" v-else>{{(item.room_name.length>=2)? item.room_name.charAt(0)+item.room_name.charAt(1):item.room_name.charAt(0)}}</span>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title class="CSChatThai NameBorder" v-text="item.room_name"></v-list-tile-title>
          <v-list-tile-sub-title class="CSChatThai">
            
            <span v-if="item.member_status === 'active'">{{setLastMessage(item)}}</span>
            <span v-else-if="item.member_status === 'pending'" style="color: #bdbdbda8 !important;">โปรดกดยืนยันเข้ากลุ่ม</span>

          </v-list-tile-sub-title>
  <!--         <v-list-tile-sub-title class="CSChatThai" style="color: #bdbdbda8 !important;" v-text="'โปรดกดยืนยันเข้ากลุ่ม'" v-else-if="item.member_status === 'pending'"></v-list-tile-sub-title> -->
        </v-list-tile-content>

        <v-list-tile-action v-if="item.member_status === 'active'">
          <span class="CSChatThai timeListChat" v-if="item.last_message_time">{{time(item.last_message_time)}} </span>
          <v-chip class="ma-2" color="red" text-color="white" v-if="item.count_not_read">
                    {{item.count_not_read}}
                </v-chip>
        </v-list-tile-action>
        <v-list-tile-action v-else-if="item.member_status === 'pending'">
          <v-chip class="ma-2" color="green" text-color="white">
            N
          </v-chip>
        </v-list-tile-action>
      </v-list-tile>



      <v-divider v-if="index != FilterChatList.length -1"></v-divider>
    </template>
  </v-list>
  <div v-else-if="TabMenu == 'chat' && listRoom.length == 0">
<!--         <Promised :promise="GetDisplayUser(msg.message_data.object)">
                  <template v-slot:pending>
                    <p>Loading...</p>
                  </template>
                  <template v-slot="data">
                  </template>
                </Promised> -->
    <span v-if="state == 'show data'" style="margin-top:10px; text-align: center;">คุณยังไม่มีห้องแชท</span>
    <!-- <span v-else>loading</span> -->
<div style="display: flex !important;justify-content: center !important; width: 100%;
    height: 65vh;
    padding: 20px;" v-else>
    <v-progress-circular
        indeterminate
        color="primary"
        :size="80"
        :width="5"


      ></v-progress-circular>
    </div>
  </div>

</div>

</div>
</div>



<div v-else-if="stateShow == 'showPendingGroup'">
<div class="CSChatThai">

<div style="background: #2562af !important; padding-bottom: 10px ;">
  <v-btn icon @click="stateShow = 'showMenu'" style="margin: 0 !important;">
        <v-icon class="white--text">chevron_left</v-icon>
      </v-btn>

      <div class="white--text" style="font-weight: 600;    white-space: nowrap;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;text-align: center;" >คำเชิญเข้ากลุ่ม ({{FilterGroupPendingList.length}}) </div>


  </div>

  <v-list two-line v-if="FilterGroupPendingList.length != 0">

      <template v-for="(item, index) in FilterGroupPendingList">
        <v-list-tile avatar @click="selectRoom(item)">
          <v-list-tile-avatar color="#2562af" size="40">
            <img :src="backend + item.room_picture" v-if="item.room_picture" class="alligator-turtle"/>
            <span class="white--text headline" v-else>{{(item.room_name.length>=2)? item.room_name.charAt(0)+item.room_name.charAt(1):item.room_name.charAt(0)}}</span>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title class="CSChatThai NameBorder" v-text="item.room_name"></v-list-tile-title>
            <!-- <v-list-tile-sub-title class="CSChatThai" v-text="item.friend_status"></v-list-tile-sub-title> -->
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="index != FilterGroupList.length -1"></v-divider>
      </template>
    </v-list>




</div>
</div>




</div>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Momenttime, Decode, Encode } from '@/services'
var _ = require('lodash')
const SUB_LIST_ROOM = gql`
subscription ($user_id: uuid!) {
  list_chat(where: {user_id: {_eq: $user_id}}, order_by: {last_message_time: desc_nulls_last}) {
    room_id
    last_message_time
    last_message
    last_message_type
    count_not_read
    room_type
    room_name
    room_picture
    friend_display_name
    friend_email
    friend_profile_picture
    friend_status
    friend_user_id
    status
    member_status
  }
}`

const SET_TIME_READ = gql`
mutation ($user_id: uuid!, $room_id: uuid!) {
  update_member(where: {room_id: {_eq: $room_id}, _and: {user_id: {_eq: $user_id}}}, _set: {time_read: "now()"}) {
    returning {
      time_read
      room_id
      member_id
    }
  }
}
`

const SUB_USER_ONLINE = gql`
subscription ($user_id: uuid!) {
  user_online(order_by: {display_name: asc}, where: {user_id: {_neq: $user_id}}) {
    user_id
    username
    display_name
    profile_picture
  }
}
`

const SUB_USER_ONLINE_V2 = gql`
subscription ($list_user_id: [uuid!]) {
  user_online(where: {user_id: {_in: $list_user_id}}) {
    display_name
    email
    profile_picture
    user_id
    status
    username
    last_seen
  }
}
`


export default {
  data: () => ({
    listRoom: [],
    user_id: '',
    listUserOnline: [],
    Authorization: {},
    TabMenu: 'chat',
    state: 'first',
    search: '',
    backend: process.env.VUE_APP_API,
    stateShow: 'showMenu'
  }),
  apollo: {
    $subscribe: {
      list_chat: {
        query: SUB_LIST_ROOM,
        variables () {
          return {
              user_id: this.user_id
          }
        },
        result (data) {
          this.listRoom = data.data.list_chat
          this.state = 'show data'
        }
      },
      // user_online: {
      //   query: SUB_USER_ONLINE,
      //   variables () {
      //     return {
      //         user_id: this.user_id
      //     }
      //   },
      //   result (data) {
      //     this.listUserOnline = data.data.user_online
      //   }
      // },
      user_online_v2: {
        query: SUB_USER_ONLINE_V2,
        variables () {
          return {
              list_user_id: _.map(this.FilterFriendList, 'friend_user_id')
          }
        },
        result (data) {
          // this.listUserOnline = data.data.user_online
          this.listUserOnline = _.map(data.data.user_online, 'user_id')
          // console.log(this.listUserOnline)
          // for (var i=0; i <= this.listUserOnline.length - 1; i += 1) {
          //   var eachUser = this.listUserOnline[i]
          //   var indexid = _.findIndex(this.listRoom, function(o) {
          //     return o.friend_user_id === eachUser 
          //   })
          //   this.listRoom[indexid].online = true
          //   // console.log(this.listRoom[indexid])
          // }
          // var indexid = _.findIndex(this.items, function(o) {
          //   return o.tokenmessage === tokenmessage && o.typeofmessage === 'approve_message'
          // })
          // this.listRoom m[indexid].disable = 'true'

        }
      }
    }
  },
  computed: {
    ...sync('*'),

    FilterFriendList () {
      if (this.search !== '' && this.search !== null) {
        // console.log(this.listRoom)
        return _.orderBy(_.partition(this.listRoom, function(o) { return o.room_type == 'user' })[0], 'friend_display_name', 'desc').filter(post => {
          return post.friend_display_name.toLowerCase().includes(this.search.toLowerCase()) || post.friend_email.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return _.orderBy(_.partition(this.listRoom, function(o) { return o.room_type == 'user' })[0], 'friend_display_name', 'desc')
      }
    },
    FilterGroupList () {
      if (this.search !== '' && this.search !== null) {
        return _.orderBy(_.partition(this.listRoom, function(o) { return (o.room_type == 'group' && o.member_status == 'active') })[0], 'room_name', 'desc').filter(post => {
          return post.room_name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return _.orderBy(_.partition(this.listRoom, function(o) { return (o.room_type == 'group' && o.member_status == 'active') })[0], 'room_name', 'desc')
      }
    },
    FilterGroupPendingList () {
      // if (this.search !== '' && this.search !== null) {
      //   return _.orderBy(_.partition(this.listRoom, function(o) { return (o.room_type == 'group' && o.member_status == 'pending') })[0], 'room_name', 'desc').filter(post => {
      //     return post.room_name.toLowerCase().includes(this.search.toLowerCase())
      //   })
      // } else {
        return _.orderBy(_.partition(this.listRoom, function(o) { return (o.room_type == 'group' && o.member_status == 'pending') })[0], 'room_name', 'desc')
      // }
    },
    FilterChatList () {
      if (this.search !== '' && this.search !== null) {
        return this.listRoom.filter(post => {
          return (post.friend_email? post.friend_email.toLowerCase().includes(this.search.toLowerCase()):false) || (post.room_name? post.room_name.toLowerCase().includes(this.search.toLowerCase()):false) || (post.friend_display_name? post.friend_display_name.toLowerCase().includes(this.search.toLowerCase()):false)
        })
      } else {
        return this.listRoom
      }
    }




    // listFriend () {
    //   // return this.listRoom
    //   // console.log(this.listRoom)
    //   // console.log(_.partition(this.listRoom, function(o) { return o.room_type == 'user' }))
    //   // return this.listRoom
    //   return _.orderBy(_.partition(this.listRoom, function(o) { return o.room_type == 'user' })[0], 'friend_display_name', 'desc')
    // },
    // listGroup () {
    //   // return this.listRoom
    //   // console.log(this.listRoom)
    //   // console.log(_.partition(this.listRoom, function(o) { return (o.room_type == 'group' && o.member_status == 'active') }))
    //   return _.orderBy(_.partition(this.listRoom, function(o) { return (o.room_type == 'group' && o.member_status == 'active') })[0], 'room_name', 'desc')
    // }
  },
  created () {
    // this.$session.set('user_id', Encode.encodeToken('eeb8855b-b330-4bc5-a1d1-e7f3c3350277'))
    this.user_id = Decode.decodeToken(localStorage.getItem('user_id'))
    // console.log(this.user_id)
    this.Authorization = {headers: {'Authorization': 'Bearer ' + Decode.decodeToken(localStorage.getItem('auth_token'))}}
  },
  watch: {
    FilterFriendList () {
      // console.log(this.FilterFriendList)
      // console.log(_.map(this.FilterFriendList, 'friend_user_id'))

    }
  },
  methods: {
    checkOnline_user (user_id) {
      if (this.listUserOnline.length != 0) {
        return this.listUserOnline.includes(user_id)
      } else {
        return false
      }
    },
    selectedTabMenu (menu) {
      this.TabMenu = menu
    },
    gotopath (path) {
      this.$router.push(path)
    },
    time (timestamp) {
      return Momenttime.momenttimethaiformnow(timestamp)
    },
    setRoomName(room) {
      if (room.room_type == 'user') {
        return room.friend_display_name
      }
      return room.room_name
    },
    setLastMessage(room) {
      if(room.last_message_type == 'text') {
        return room.last_message.text
      } else if (room.last_message_type == 'image') {
        return 'ส่งรูปภาพ'
      } else if (room.last_message_type == 'file') {
        return 'ส่งไฟล์'
      } else if (room.last_message_type == 'audio') {
        return 'ส่งไฟล์เสียง'
      } else if (room.last_message_type == 'video') {
        return 'ส่งวิดีโอ'
      }   
      return ''
    },
    selectRoom(room) {
      if (room.member_status == 'active') {
        this.setTimeRead(room.room_id)
      }
      this.$router.push('/chat_room?id=' + room.room_id)
    },
    selectRoom_userOnline(user_id) {
      var reqestBody = {
        "user_id": this.user_id,
        "username_friend": user_id
      }
      this.axios.post(process.env.VUE_APP_API + '/createRoomByEmail', reqestBody, this.Authorization).then((response) => {
        this.$router.push('/chat_room?id=' + response.data.data.room_id)
        this.setTimeRead(response.data.data.room_id)
      })
    },
    setTimeRead(room_id) {
      this.$apollo.mutate({
        mutation: SET_TIME_READ,
        variables: {
          user_id: this.user_id,
          room_id: room_id
        }
      })
    }
  }
    
} 
</script>
<style type="text/css" scoped>
.CSChatThai {
 /*font-family: 'CS ChatThaiUI' !important;*/
 word-wrap: break-word;
}
>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    background: #3978c7 !important;
    border-radius: 38px !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
  font-size: 15px;
}
>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border: 0 !important;
  font-size: 15px;
}

.colorAvatar {
  color: #2562af !important;
}
.timeListChat {
  color: #adadad;
  font-size: 10px;
}

>>>.v-badge--bottom .v-badge__badge {
  border: #2562af 2px solid !important;
  bottom: -6px !important;
}
>>>.v-badge__badge {
  height: 14px !important;
  width: 14px !important;
  right: -16px !important;
}
>>>.v-list--two-line .v-list__tile {
  height: 65px !important;
}

.defaultPicOnline {
  cursor: pointer;
  background: #2663af !important;
}
.defaultPicOnlinehavePic {
  cursor: pointer;
}
>>>.v-input__icon .v-input__icon--prepend-inner .v-icon {
  font-size: 13px !important;
}
>>>.v-icon {
  font-size: inherit;
}
>>>.theme--light.v-list .v-list__tile__sub-title {
  font-size: 12px;
}
.Menu_headerStyle {
  text-align: center;
  color: white;
  border-radius: 10px;
  cursor: pointer;
  margin: 0 4px;
}
.Menu_headerStyle_Selected {
  text-align: center;
  color: white;
  border-radius: 10px;
  cursor: pointer;
  background: #ffffff3b !important;
  margin: 0 4px;
}
.Menu_headerStyle:hover {
  background: #0000001c !important;
}

.createGroupStyle {
  background: #f3f3f3;
  padding: 10px;
  cursor: pointer;
  width: 100%;
}
>>>.v-chip .v-chip__content {
    height: auto !important;
    padding: 0 5px !important;
}
.NameBorder {
  font-weight: 600 !important;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}



.bgsearchweb {
  /*background-color: #232a35 !important;*/
  color: white !important;
  border-radius: 100px !important;
  font-size: 12px !important;
  margin-top: 2vh !important;
  margin-bottom: 2vh !important;
      width: 85vw;
}
>>> .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: rgba(255, 255, 255, 0.87);
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    box-shadow: none;
    background: rgba(0, 0, 0, 0.11) !important;
    border-radius: 100px !important;
    font-size: 12px !important;
}
>>> .v-text-field.v-text-field--enclosed .v-text-field__details {
     margin-bottom: 0px;
}
>>> .bgsearchweb label {
  color: white !important;
  font-size: 14px;
}
>>> .input-group__input input {
  color: white !important;
}
>>> .theme--light.v-icon {
    color: white;
}

>>>.theme--light.v-icon:focus{
    color: white;
}

>>>.primary--text {
  color: white !important;
}

>>>.v-badge--bottom .v-badge__badge {
    border: white 2px solid !important;
    bottom: -3px !important;
    right: 0px !important;
}
>>>.v-list {
    padding: 2px 0 !important;
}

::-webkit-scrollbar {
  /*width: 10px;*/
}


/*>>> .spanOnline .v-badge--bottom .v-badge__badge {
    border: white 2px solid !important;
    bottom: -6px !important;
    right: 0px !important;
    }

>>>.spanOnlinehavePic.v-badge--bottom .v-badge__badge  {
    border: white 2px solid !important;
    bottom: -8px !important;
    right: 0px !important;
    }*/

/*[data-v-9666909e] .v-badge__badge {
    height: 14px !important;
    width: 14px !important;
    right: 0px !important;*/
/*.v-text-field.v-text-field--solo .v-label {
    top: calc(50% - 10px);
    font-size: 14px;
}*/
</style>


// WEBPACK FOOTER //
// src/components/mail/ListRoom.vue